
import { useEffect, useRef } from "react";
import { Check } from "lucide-react";
import { useLanguage } from "@/contexts/LanguageContext";

const Features = () => {
  const sectionRef = useRef<HTMLElement>(null);
  const { t } = useLanguage();

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("revealed");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1 }
    );

    const elementsToObserve = sectionRef.current?.querySelectorAll(".reveal-on-scroll");
    elementsToObserve?.forEach((el) => {
      observer.observe(el);
    });

    return () => {
      elementsToObserve?.forEach((el) => {
        observer.unobserve(el);
      });
    };
  }, []);

  const features = [
    t('features_list1'),
    t('features_list2'),
    t('features_list3'),
    t('features_list4'),
    t('features_list5'),
    t('features_list6')
  ];

  return (
    <section ref={sectionRef} id="features" className="py-20 bg-white dark:bg-gray-900">
      <div className="container mx-auto px-6">
        <h2 className="text-3xl md:text-4xl font-bold mb-12 text-center reveal-on-scroll dark:text-gray-50">
          {t('features_title')}
        </h2>
        
        <div className="grid md:grid-cols-2 gap-8 items-center">
          <div className="reveal-on-scroll">
            <img 
              src="https://sooovuvamgyafqsqehbo.supabase.co/storage/v1/object/public/images/main.webp" 
              alt="Wind turbines and energy optimization" 
              className="w-full h-auto rounded-2xl shadow-subtle-lg"
              loading="lazy"
              decoding="async"
              width="800"
              height="600"
            />
          </div>
          
          <ul className="space-y-4 reveal-on-scroll">
            {features.map((feature, index) => (
              <li key={index} className="flex items-start">
                <div className="flex-shrink-0 w-6 h-6 rounded-full bg-primary/10 dark:bg-primary/20 flex items-center justify-center mr-3 mt-0.5">
                  <Check className="w-4 h-4 text-primary" />
                </div>
                <span className="text-gray-700 dark:text-gray-300">{feature}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
};

export default Features;
